import { HttpErrorResponse } from '@angular/common/http';
import { DestroyRef, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ToastService } from 'mbs-ui-kit';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getErrorText } from './get-error-text';
import { hasErrorResponseText } from './has-error-response-text';

export function trackModalRequest(): <T>(source$: Observable<T>) => Observable<T> {
  const destroyRef = inject(DestroyRef);
  const i18nPipe = inject(I18NextPipe);
  const toastService = inject(ToastService);

  return <T>(source$: Observable<T>) =>
    source$.pipe(
      catchError((res: HttpErrorResponse) => {
        if (!destroyRef.destroyed) {
          return throwError(() => res);
        }

        if (hasErrorResponseText(res)) {
          toastService.error(getErrorText(res), i18nPipe.transform('toast.error.title', { format: 'capitalize' }));
        }

        return EMPTY;
      })
    );
}
